import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import classes from "./Tabs.module.css";
import Colors from "../assets/Colors";
import Fonts from "../assets/Fonts";

export const Tabs = ({ state, setState, tabsData, matchWithActiveText }) => {
  const scrollRef = useRef(null)

  useEffect(() => {
    scrollRef.current !== undefined && scrollRef.current !== null && scrollRef.current?.scrollIntoView({ inline: 'start', behaviour: 'smooth', block: 'nearest' })
  }, [state])


  return (
    <div
      className={`${[classes.TabsContainer].join(" ")}`}
      style={{ borderBottomColor: Colors.neutralShadesOfWhisper }}
    >
      <style jsx>{`
        .${classes.tab} {
          color: ${Colors.neutralShadesOfDimGray};
          font-size: ${Fonts.p1.fontSize};
          line-height: ${Fonts.p1.lineHeight};
          font-family: ${Fonts.p1.fontFamily};
          border-bottom: 4px solid transparent;
        }
        .${classes.tab} .${classes.counts} {
          color: ${Colors.neutralShadesOfNero};
          background-color: ${Colors.mainShadeOfSolitude};
        }
        .${classes.tabSelected} {
          color: ${Colors.errorColor};
          font-size: ${Fonts.h7.fontSize};
          line-height: 24px;
          font-family: inter-600;
          border-bottom: 4px solid ${Colors.errorColor};
        }
        .${classes.tabSelected} .${classes.counts} {
          color: #ec2237;
          background-color: ${Colors.errorColor}14;
        }
      `}</style>
      <ul>
        {tabsData?.map((item, i) => {
          return (
            <li
              className={`${[
                matchWithActiveText
                  ? state?.label?.toLowerCase() ==
                    item?.activeText?.toLowerCase()
                    ? classes.tabSelected
                    : classes.tab
                  : state?.label?.toLowerCase() == item?.label?.toLowerCase()
                    ? classes.tabSelected
                    : classes.tab,
              ].join(" ")}`}
              onClick={() => {
                setState(item);
              }}
              ref={(
                matchWithActiveText ?
                  state?.label?.toLowerCase() ==
                  item?.activeText?.toLowerCase()
                  :
                  state?.label?.toLowerCase() == item?.label?.toLowerCase()
              ) ?
                scrollRef : null
              }
            >
              {item?.label}{" "}
              {item?.value >= 0 && (
                <span className={classes.counts} style={{ ...Fonts.input3 }}>
                  {item?.value}
                </span>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

Tabs.propTypes = {
  tabsData: PropTypes.array,
  state: PropTypes.string,
  setState: PropTypes.func,
};

Tabs.defaultProps = {
  tabsData: [
    { label: "All", value: 14 },
    { label: "Upcoming", value: 14 },
    { label: "Pending", value: 16 },
  ],
  state: { label: "All", value: 14 },
};
